import React from 'react';
import { string } from 'prop-types';
import { buildQuestion } from '../../../logics/questionBuilder';


const QuizSentenceBase = ({content, renderBlank}) => {
	const quizText = buildQuestion(content, 
		(text,index)=>{
			return <span key={text+index}>{text}</span>;
		},
		(answer,index)=>{
			return renderBlank({answer, index});
		});
	return quizText;
};
QuizSentenceBase.propTypes = {
	content: string,
};

export default QuizSentenceBase;